<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title
        style="background-color: var(--secondary-color); padding: 10px"
      >
        <label style="color: white; font-weight: 600; font-size: 20px">
          Histórico de abastecimento
        </label>
      </v-card-title>
      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row>
            <v-col>
              <v-dialog
                ref="dialog_begin"
                v-model="modal_begin"
                :return-value.sync="begin_date"
                persistent
                lazy
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="begin_date"
                    label="Data inicio"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="begin_date"
                  scrollable
                  :header-color="header_color"
                >
                  <v-spacer></v-spacer>
                  <v-btn text @click="modal_begin = false">
                    Cancelar
                  </v-btn>

                  <v-btn
                    color="primary"
                    @click="$refs.dialog_begin.save(begin_date)"
                  >
                    Selecionar
                  </v-btn>
                </v-date-picker>
              </v-dialog></v-col
            >
            <v-col>
              <v-dialog
                ref="dialog_end"
                v-model="modal_end"
                :return-value.sync="end_date"
                persistent
                lazy
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="end_date"
                    label="Data final"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="end_date"
                  scrollable
                  :header-color="header_color"
                >
                  <v-spacer></v-spacer>
                  <v-btn text @click="modal_end = false">
                    Cancelar
                  </v-btn>

                  <v-btn
                    color="primary"
                    @click="$refs.dialog_end.save(end_date)"
                  >
                    Selecionar
                  </v-btn>
                </v-date-picker>
              </v-dialog></v-col
            >
            <v-col>
              <v-btn
                block
                color="info"
                class="mt-4 white--text"
                @click="validateFields()"
              >
                Buscar
              </v-btn></v-col
            >
            <v-col>
              <v-btn
                block
                color="white"
                class="mt-4 black--text"
                @click="clearFilters"
              >
                Limpar filtros
              </v-btn></v-col
            >
          </v-row>
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          :headers="headers"
          :items="data"
          :search="search"
          class="elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class>{{ item.id }}</td>
              <td class>{{ item.user.name }}</td>
              <td class>{{ item.vehicle_request_id }}</td>
              <td class>
                {{ item.benefit_application_method | formatBenefitMethod }}
              </td>
              <td class>{{ item.value | formatValue }}</td>
              <td class>{{ item.created_at | formatDate }}</td>
              <td>
                <ActionButton
                  message="Visualizar Comprovante"
                  icon="assignment"
                  @onclick="selectSupply(item.url_nfs)"
                />
                <ActionButton
                  message="Detalhes da reserva"
                  icon="open_in_new"
                  color="info"
                  @onclick="detail(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Comprovante</span>
        </v-card-title>
        <v-card-text>
          <v-img
            lazy-src="https://picsum.photos/id/11/10/6"
            max-height="229"
            max-width="362"
            :src="`${url_bucket + url}`"
          ></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showModal = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import moment from 'moment';
import HistoricoAbastecimentoController from '../../controllers/HistoricoAbastecimentoController';
import Constants from '../../models/constants/Constants';

export default {
  components: {
    ActionButton,
  },
  async created() {
    await this.getSupplyHistory();
  },
  data() {
    return {
      begin_date: null,
      end_date: null,
      header_color: 'blue',
      modal_begin: false,
      modal_end: false,
      search: '',
      historicoAbastecimentoController: new HistoricoAbastecimentoController(
        this.$resource
      ),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      headers: [
        { text: 'ID', value: 'supply.id' },
        { text: 'Usuário', value: 'user.name' },
        { text: 'ID da reserva', value: 'vehicle_request_id' },
        {
          text: 'Método de aplicação do benefício',
          value: 'supply.benefit_application_method',
        },
        { text: 'Valor', value: 'supply.value' },
        { text: 'Data', value: 'supply.created_at' },
        { text: 'Ações', value: 'acoes', sortable: false },
      ],
      data: [],
      showModal: false,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      url: null,
    };
  },
  methods: {
    async clearFilters() {
      await this.getSupplyHistory();
      this.begin_date = null;
      this.end_date = null;
    },
    async validateFields() {
      try {
        if (this.begin_date === null || this.end_date === null) {
          let msg = 'Preencha todos os campos';
          throw new Error(msg);
        } else if (this.begin_date >= this.end_date) {
          let msg = 'A data de início deve ser menor que a data final';
          throw new Error(msg);
        } else {
          await this.getSupplyHistoryBetweenDates();
        }
      } catch (error) {
        return this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },
    async getSupplyHistory() {
      try {
        this.blockScreen = true;
        const response = await this.historicoAbastecimentoController.getSupplyHistory();
        this.data = response;
      } catch (error) {
        console.error(err);
      } finally {
        this.blockScreen = false;
      }
    },
    async getSupplyHistoryBetweenDates() {
      try {
        this.blockScreen = true;
        const response = await this.historicoAbastecimentoController.getSupplyHistoryBetweenDates(
          this.begin_date,
          this.end_date
        );
        this.data = response;
      } catch (error) {
        console.error(error);
      } finally {
        this.blockScreen = false;
      }
    },

    selectSupply(url) {
      this.showModal = true;
      this.url = url;
    },

    detail(item) {
      let routeData = this.$router.resolve({
        name: 'tcs-vehicle-request-detail',
        params: {
          id: item.vehicle_request_id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },
  },
  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },

    formatValue(value) {
      let valorFloat = parseFloat(value / 100);
      let formatado = 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
      return formatado;
    },

    formatBenefitMethod(type) {
      const method = {
        USER_PLAN: 'Saldo de horas',
        CURRENT_RESERVATION: 'Prorrogação da reserva',
        COUPON_GENERATED: 'Gerado voucher de 30min',
      };

      return method[type] ? method[type] : 'Método desconhecido';
    },
  },
};
</script>
<style>
.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
